import { Component, OnInit } from '@angular/core';
import { CmsComponentData } from '@spartacus/storefront';
import { UigCustomCmsLinkComponent } from './uig-cms.model';
import { Observable } from 'rxjs';
import { combineLatest, map } from 'rxjs';
import { AuthStorageService } from '@spartacus/core';

@Component({
    selector: 'app-uig-cms-link',
    templateUrl: './uig-cms.component.html',
    styleUrls: ['./uig-cms.component.scss'],
    standalone: false
})
export class UigCmsLinkComponent implements OnInit {

  cmsData$: Observable<{ url: string; linkName: string }>;
  

  constructor(
    protected componentData: CmsComponentData<UigCustomCmsLinkComponent>,protected authStorageService:AuthStorageService
  ) {}

  ngOnInit(): void {
    this.cmsData$ = combineLatest([
      this.componentData.data$,
      this.authStorageService.getToken()
    ]).pipe(
      map(([data, token]) => {
        let finalUrl = data.url || '';
        const addIdBool = (data.addId === true || data.addId === 'true');
        if (addIdBool === true && token?.access_token) {
          finalUrl += finalUrl.includes('?') ? '&' : '?';
          finalUrl += `id=${token.access_token}`;
        }
        return {
          url: finalUrl,
          linkName: data.linkName || 'Open Link',
          styleClasses: data.styleClasses
        };
      })
    );
  }
    

}
